import { connect } from 'react-redux';
import * as Immutable from 'immutable';
import Prerequisite, { Props } from '../_components/Prerequisite';
import { Dispatch } from 'redux';
import { GetFabrics, GetCountries } from '../../UIData/_actions/UIDataActions';
import { GetUserCart } from '../../UserData/_actions/UserCartActions';

const mapStateToProps = (store:Immutable.Record<any>, props:Props) => ({
	loading: store.getIn(['UIData', 'loaders', props.name])
});

const mapDispatchToProps = (dispatch:Dispatch, props:Props) => ({
	getCountries: () => {dispatch(GetCountries())},
	getFabrics: () => {dispatch(GetFabrics())},
	getUserCart: () => {dispatch(GetUserCart())}
});

export default connect(
	mapStateToProps, mapDispatchToProps
)(Prerequisite);